// Importing React and external libs
import React, { useEffect, useState } from 'react';

// Importing helix hooks
import useLanguage from 'helix-hooks/language';

// Importing component languages
import languages from '../lng';

// Importing CSS
import './style.scss';


const FailedLoginAttempts = ({ loginAttemptResponse = {} }) => {
  const Language = useLanguage({ languages });

  const [failedAttempts, setFailedAttempts] = useState(loginAttemptResponse?.['failed_attempts'] || 0);
  const [remainingAttempts, setRemainingAttempts] = useState(loginAttemptResponse?.['remaining_attempts'] || 0);

  useEffect(() => {
    setFailedAttempts(loginAttemptResponse?.['failed_attempts'] || 0);
    setRemainingAttempts(loginAttemptResponse?.['remaining_attempts'] || 0);
  }, [loginAttemptResponse]);

  return (
    <div className="failed-attempt">
      {failedAttempts > 0 && remainingAttempts > 0 && (
        <>
          {failedAttempts} {Language.get('login', 'FAILED')} {Language.get('login', failedAttempts === 1 ? 'ATTEMPT' : 'ATTEMPTS')}.
          {remainingAttempts} {Language.get('login', remainingAttempts === 1 ? 'ATTEMPT' : 'ATTEMPTS')} {Language.get('login', 'REMAINING')}.
        </>
      )}
    </div>
  );
};

export default FailedLoginAttempts;
